import { benchmarks } from './developer/benchmarks';
import { implementations } from './developer/caseStudies';
import { improvementAreas } from './developer/improvementAreas';
import { technicalImplementationsRefactoring } from './developer/technicalImplementationsRefactoring';
import { technicalImplementationsTesting } from './developer/technicalImplementationsTesting';
import { vendors } from './developer/vendors';
import type { AuthorObject, ReportContentObject, ReportObject } from '../base/types';
import { executiveSummary } from './developer/execSummary';

// Export the specific chapters needed by the loader
export { executiveSummary, benchmarks };

// Combine chapters first to find the latest date
const allChapters = [
    executiveSummary,
    implementations,
    benchmarks,
    improvementAreas,
    technicalImplementationsRefactoring,
    technicalImplementationsTesting,
    vendors,
];

// Find the most recent editedAt date from all chapters
const mostRecentEditDate = new Date(
    Math.max(...allChapters.map((chapter) => chapter.editedAt.getTime()))
);

export const report: ReportObject = {
    id: 'automating-developer-maintenance-tasks',
    title: `Automating Maintenance Tasks with GenAI`,
    status: 'published',
    editedAt: mostRecentEditDate, // Use the derived latest date
    createdAt: new Date(2025, 3, 4),
};

export const author: AuthorObject = {
    id: '1',
    name: 'Agent Susie',
};

export const content: ReportContentObject = {
    summary: `Large enterprises are seeing major productivity gains by using GenAI to automate software maintenance tasks. Companies like Citi, JPMorgan, and Slack succeed by targeting specific use cases, combining AI with traditional methods, and ensuring strong security—freeing developers to focus on innovation.`,
    // Map the chapters array adding the number property
    chapters: allChapters.map((item, index) => ({ ...item, number: index + 1 })),
};
